/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import {
  PANELACTIVE,
} from './mutation-types'

export default {
  [PANELACTIVE](state, bstate) {
    state.panelActive = bstate
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/sinisters/mutations.js